import { SetStateAction } from 'react';

import { DateInput } from 'coreOld/components';
import { Grid } from 'coreOld/elements';
import { Size } from 'coreOld/enums';

interface IProps {
  startDate: Date;
  endDate: Date;
  setStartDate: React.Dispatch<SetStateAction<Date>>;
  setEndDate: React.Dispatch<SetStateAction<Date>>;
  value?: string;
}

const DateRangeView = ({ startDate, endDate, setStartDate, setEndDate }: IProps) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <DateInput
          selected={startDate}
          startDate={startDate}
          onChange={(date) => setStartDate(date)}
          placeholder="From"
          size={Size.MD}
          showBorder={true}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <DateInput
          selected={endDate}
          endDate={endDate}
          startDate={startDate}
          minDate={startDate}
          onChange={(date) => setEndDate(date)}
          placeholder="To"
          size={Size.MD}
          showBorder={true}
        />
      </Grid>
    </Grid>
  );
};

export default DateRangeView;
